export default __webpack_public_path__ + "static/media/moss-on-bricks.1638c723.jpg";